import { AnaliseDaAdega } from '../components/AnaliseDaAdega.js';
import { EmptyState } from '../components/Feedback.js';
import { LinhaDoTempo } from '../components/LinhaDoTempo.js';
import { PageHeader } from '../components/PageHeader.js';
import { useRetrato } from '../api/queries.js';

/**
 * "Como está sua adega": o diagnóstico, separado da contagem.
 *
 * "Sua adega em números" responde o que existe. Esta responde o que fazer a
 * respeito — e as duas coisas confundiam quando moravam na mesma tela.
 *
 * A ordem aqui é deliberada: primeiro a conta (grátis, instantânea, sempre
 * igual), depois o conselho (uma chamada de IA, por clique). Quem só quiser
 * saber quando a adega vence nunca precisa gastar nada.
 */
export function ComposicaoDaAdega() {
  const { data: retrato } = useRetrato();

  return (
    <div className="space-y-4">
      <PageHeader
        titulo="Como está sua adega"
        subtitulo="Quando vence, o que falta, o que comprar"
        voltar="/"
      />

      {retrato && retrato.garrafas === 0 ? (
        <EmptyState
          titulo="Ainda não há o que analisar"
          descricao="Cadastre suas garrafas e volte aqui: o diagnóstico sai do que estiver guardado."
        />
      ) : (
        <>
          <LinhaDoTempo />
          <AnaliseDaAdega />
        </>
      )}
    </div>
  );
}
